import React from "react";

function SocialButtonLandingPage(props) {
  return (
    <div className="social-button-container">
      <div
        className="social-button-line cursor-pointer"
        onClick={() => window.open("line://ti/p/@706ktpyd")}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <mask
            id="mask0_3277_57"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="20"
          >
            <rect width="20" height="20" fill="url(#pattern0)" />
          </mask>
          <g mask="url(#mask0_3277_57)">
            <rect
              x="-2.22266"
              y="-3.70374"
              width="22.2222"
              height="23.7037"
              fill="#fff"
            />
          </g>
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_3277_57" transform="scale(0.00694444)" />
            </pattern>
            <image
              id="image0_3277_57"
              width="144"
              height="144"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>
      </div>
      <div
        className="social-button-telegram cursor-pointer"
        onClick={() => window.open("https://t.me/IUXMarkets_bot")}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <mask
            id="mask0_3277_34"
            style={{ maskType: "alpha" }}
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="20"
          >
            <rect width="20" height="20" fill="url(#pattern1)" />
          </mask>
          <g mask="url(#mask0_3277_34)">
            <rect
              x="-7.77734"
              y="-7.77783"
              width="48.8889"
              height="48.8889"
              fill="white"
            />
          </g>
          <defs>
            <pattern
              id="pattern1"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_3277_34" transform="scale(0.0104167)" />
            </pattern>
            <image
              id="image0_3277_34"
              width="96"
              height="96"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>
      </div>
      <div
        className="social-button-facebook cursor-pointer"
        onClick={() => window.open("https://m.me/1318672661620043")}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <mask
            id="mask0_3277_36"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="20"
          >
            <rect width="20" height="20" fill="url(#pattern2)" />
          </mask>
          <g mask="url(#mask0_3277_36)">
            <rect x="-6" y="-8" width="44" height="50" fill="white" />
          </g>
          <defs>
            <pattern
              id="pattern2"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_3277_36" transform="scale(0.0104167)" />
            </pattern>
            <image
              id="image0_3277_36"
              width="96"
              height="96"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFQElEQVR4nO2dS2heRRTHf2laX/HRFnXtyoXiq0EUTUXFhRsXilqK4kaxorTiRvFBE7VIREtNEMGN9YVYxVUFX63vt9EWtVpLG60VRQ2FVBc1rR4ZOIFLSPLdx9w7Z+43P/hvypd75/xnOvfOzLkzkEgkEolEIjGDhcA5wArgPuAZ4CNgB/AjsB+YUu3Xf9uhv3G/vRe4Fjhbr5XoQC9wIXAP8DrwFyCedAB4DbgbuEDvlVBOB4aBXz0a3kkTwJPAANBDF9IHrAZ2NWj6XNqlZXFlaj0nAw9oCxRjcmW6HziJFrIIuB2YNGC0dNDfwBBwFC3hCmC3AWOloFyZryFiTgBeMGCkVNQrwFIi4xJgnwHzxJN+Bi4mAnq0//zXgGniWYeBtZZfW48AnjNglNSsTRYf0EuAdwyYIw3pQ+BEDD1sxwyYIg1ruza8oBwDvG/ADAmkT4BjQ5l/NPC2ARMksLaEeiY8bSB4MaLnmzZ/tYGgxZhuacr884F/DAQsxjSl6xm14h44ew0EK0Y1Xve09oiBIMW4Hq3L/HN1OB46QDEu51G/b/MX6MAjdHASicZ8zxmtMBCURKarfLb+rw0EJJHpW/WuMisNBCORysuK2hcGApFI9VlV888wEIRErjOrVEB676dyBayvssJlMX9HItMfmpZTmEsNFF5aoovKVMBDBgouGX0PPKIJtpsiG5Wvi/3tZ712iVnOAn6o+b6ukl/SbO1G34aWGkotGZqnnG5N9q0a7jmplX6K3t9HRS4pmlglBjSYo6y9mt7u437uI4+7Mmb5ML/Uc+DWSMzPcrMuipSdPLthxpc0Ps13WkUBRiMzf5rlwJ857+G62M1zrGL5Nt9pAwV402ifn4dTOzycs/07DZkv+iDPzfZIzZ/G9eEvztK/3wEcz9zUZb7TNgowHrH5WVwrvwxYlmNquE7znfZQgIlI+nxf1G3+9JREbppMOxmk/eY7HSxSKPfjZD7hKsD9d0ktn3Bd0G4j3c5xOsAa09FubN1OVs7T3HwV2Px+/ZL9wIy/HY7UfFFPgw/EhnK2dil5DavmFx6IjTbY8vvnaO3zaTgy8wtPRayq2fy8rV08VUJo80Xjzc1ATeaXae1SsRIsmC86UVhoLuU/Dzcd8tTapcM9rJvvFmQWU5Cqhm323NplHo3MyMvvMzClntWnlGCdgYJLAbmKfk/VRKUX0YNlKmC5gYJLS1So/59moW6GF7rwErl+L5uY5XjcQADSzZ8snWYgAOnm5Fx0Y4rQQUi3pqc7rjMQiHTzBxq9uiNt6GAkMn3j6xMl9IOz0AFJZLoSj/ToaC50UBKJPq9ja7MBQwm7YliHdNPxWthgIEAxroepeZOmnQaCFKPao7uI1b5dzSEDwYoxHdT9NBphjYGAxZhuomGeMBC0GNGzBMDN8G01ELwE1hvAkQRicZePDz5o4qHbib4u2zVXLG3cmq2ELQZMkYa0tcwie91cbsAYaUAbq6xw1UnbX00P69lkZmnza+nesvs9NElbX0lftvSwnY9fDJglns8Xi+YQnz5PqYxi6BirYIOrMiwzYJx4+IRo0NLJGN2ys+JO4DYLI9oqlMlCntINmNzxUI/pUVFNmb5PE6a8bzEciqIHtr2rp6hm6dG1hrV69KzPYw/dtV4F7gTO85mtYIUvcxrxG3B9zgXrBZpVtlIPdN6o59V8B/w0y4HO45oK4ibIntKtza7Wa7T+/ODJHKPIUT1xKVED8+0t8bEeK56okdmyJdzGSTdaPvqvTSzSTZAm1PiRGE8gTSQSiUQiQffwPwKZVQr5tfndAAAAAElFTkSuQmCC"
            />
          </defs>
        </svg>
      </div>
    </div>
  );
}

export default SocialButtonLandingPage;
